// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SignUpPage_wrapper__3DoMo","toggleWrapper":"SignUpPage_toggleWrapper__2qxGn"};